module.exports = __webpack_public_path__ + "img/menu-device.ae73ef43.svg";